export const checkAudioPermissionStatus = async () => {
    try {
        const storedPermission = localStorage.getItem("audioPermission");
        if (storedPermission === "granted") {
            return "granted";
        }
        // Permissions API
        if ("permissions" in navigator) {
            const permissionStatus = await navigator.permissions.query({ name: "microphone" });
            return permissionStatus.state; // either 'granted', 'denied', or 'prompt'
        }

        // fallback method: getUserMedia
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            stream.getTracks().forEach((track) => track.stop());
            // if that works, permission is already granted
            return "granted";
        } catch (error) {
            return error.name === "NotAllowedError" ? "denied" : "prompt";
        }
    } catch (error) {
        console.error("Error checking your audio permissions:", error);
        return "unknown";
    }
};

export const checkAudioPermissionStatusWithSetter = async (
    setPermissionState,
    setAudioPermissionIsDenied
) => {
    try {
        const storedPermission = localStorage.getItem("audioPermission");
        if (storedPermission === "granted") {
            setPermissionState("granted");
            return;
        }
        // Permissions
        //  API (most reliable)
        if ("permissions" in navigator) {
            const permissionStatus = await navigator.permissions.query({ name: "microphone" });
            setPermissionState(permissionStatus.state); // either 'granted', 'denied', or 'prompt'
            return;
        }

        // fallback method: getUserMedia
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            stream.getTracks().forEach((track) => track.stop());
            // if that works, permission is already granted
            setPermissionState("granted");
            return;
        } catch (error) {
            setAudioPermissionIsDenied(error.name === "NotAllowedError");
            setPermissionState(error.name === "NotAllowedError" ? "denied" : "prompt");
            return;
        }
    } catch (error) {
        console.error("Error checking your audio permissions:", error);
        setPermissionState("unknown");
    }
};
